import { TextField, Button } from '@material-ui/core'
import React from 'react'
import { useFormik } from 'formik'
import axios from 'axios'
import { useRecoilState } from 'recoil'
import { banksState } from '../recoil/atoms'


const AddBank = props => {
    const [banks, setBanks] = useRecoilState(banksState)
    const formik = useFormik({
        initialValues: {
            name: ""
        },
        onSubmit: values => {
            axios.post('accounts/bank/', {
                name: values.name
            }).then(result => {
                setBanks([...banks, result.data])
                props.setPopup(false)
            })
        }
    })
    return (
        <form onSubmit={formik.handleSubmit}>
            <TextField
                id="name"
                label="نام بانک"
                fullWidth
                value={formik.values.name}
                onChange={formik.handleChange}
            />
            <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                style={{ marginTop: 10 }}
                disabled={formik.isSubmitting}
            >
                افزودن
            </Button>
        </form>
    )
}

export default AddBank